import { render, staticRenderFns } from "./土地咨询.vue?vue&type=template&id=5b771b26&scoped=true"
import script from "./土地咨询.vue?vue&type=script&lang=js"
export * from "./土地咨询.vue?vue&type=script&lang=js"
import style0 from "./土地咨询.vue?vue&type=style&index=0&id=5b771b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b771b26",
  null
  
)

export default component.exports